module.exports = __webpack_public_path__ + "img/new_arrow-right.01c5d2ff.svg";